import React from "react";
import HeaderComponent from "../Home/Header/Header";
import styles from "../Home/Hero/styles.module.css";
import Marquee from "../Home/  Marquee/Marquee";
import { useSiteAssets, optimized } from "../../siteAssets";

const UpCycledd = () => {
  const cartItemCount = 0;
  const assets = useSiteAssets();
  const custom = assets["upcycled-banner"];
  return (
    <div
      className={styles.upCly}
      style={
        custom
          ? {
              backgroundImage: `linear-gradient(to top, rgba(15,13,11,0.66), rgba(15,13,11,0.15)), url(${optimized(custom)})`,
            }
          : undefined
      }
    >
      <Marquee />
      <HeaderComponent cartCount={cartItemCount} />

      <p className={styles.newArrPar}>
        upcycled <br />
        collection
      </p>
   <div className={styles.newArrParPO}>
   <p className={styles.newArrPar1}>Shop all of Lormami’s latest drops</p>
   {/* <button>SORT BY</button> */}
   </div>
    </div>
  );
};

export default UpCycledd;
